import {html, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import componentStyles from './doctors-and-providers.css.lit.ts';
import {OutlineElement} from '../../base/outline-element/outline-element.ts';

export default class DoctorsAndProviders extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      searchString: {type: String},
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.getProvidersCount();
  }

  constructor() {
    super();
    this.content = html`
          Doctors &amp; <br/> Providers (loading...)
        `;
    this.providersCount = 0;
    this.searchString = '';
  }

  async getProvidersCount() {
    const encodedSearch = encodeURIComponent(this.searchString || '');
    const requestPath = 'hf-api/getProvidersCount';
    const baseUrl = window.Drupal?.url
      ? Drupal.url(requestPath)
      : `/${requestPath}`;
    const url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}search=${encodedSearch}`;

    try {
      const response = await fetch(url, {
        method: 'post',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error(
          `Request to "${url}" failed with status ${response.status}`
        );
      }

      const contentType = response.headers.get('content-type') || '';
      if (!contentType.toLowerCase().includes('application/json')) {
        const previewText = (await response.clone().text()).trim().slice(0, 120);
        throw new Error(
          `Expected JSON but received "${contentType}" from "${url}". Preview: ${previewText}`
        );
      }

      const data = await response.json();
      this.providersCount = data?.providersCount ?? 0;
      this.content = html`
          Doctors &amp; <br/> Providers (${this.providersCount})
        `;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('Provider count lookup failed', error);
      }
      this.content = html`
          Doctors &amp; <br/> Providers
        `;
    } finally {
      this.requestUpdate();
    }
  }

  render() {
    return html`
      <hf-button
        ignoreExternalUrl
        target="_blank"
        href="https://providers.hf.org/search?unified=${this.searchString}"
        type="search-external"
        icon="external-link">
          ${this.content}
      </hf-button>
    `;
  }
}

customElements.define('hf-doctors-and-providers', DoctorsAndProviders);

